"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarWithTabsWrap = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _material = require("@mui/material");
var _Calendar = require("./Calendar");
var _CalendarTabs = require("./CalendarTabs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @todo remove minDate */
const CalendarWithTabsWrap = _ref => {
  let {
    dateType,
    setParams,
    from,
    to
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_CalendarTabs.CalendarTabs, {
    dateType: dateType,
    setParams: setParams
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_Calendar.Calendar, {
    minDate: (0, _moment.default)('03.01.2022'),
    openTo: dateType,
    dateFrom: from,
    dateTo: to,
    setParams: setParams
  })));
};
exports.CalendarWithTabsWrap = CalendarWithTabsWrap;